import { render, staticRenderFns } from "./BtnCheckbox.vue?vue&type=template&id=4a4f8ddc&scoped=true"
import script from "./BtnCheckbox.vue?vue&type=script&lang=js"
export * from "./BtnCheckbox.vue?vue&type=script&lang=js"
import style0 from "./BtnCheckbox.vue?vue&type=style&index=0&id=4a4f8ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4f8ddc",
  null
  
)

export default component.exports